/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useState } from "react";

// react-router-dom components
import { Link, useNavigate } from "react-router-dom";
import { IconButton, InputAdornment } from "@mui/material";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MuiLink from "@mui/material/Link";

// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import GitHubIcon from "@mui/icons-material/GitHub";
import GoogleIcon from "@mui/icons-material/Google";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import { setLoggedIn, setToken, setUser, useMaterialUIController, setLicenseMessage , setRefreshToken} from "../../../context";
import useApi from "../../../components/Utils/api";
import toast from "react-hot-toast";

function Basic() {
  const [controller, dispatch] = useMaterialUIController();
  const {isLoggedIn} = controller;
  const api = useApi();
  const navigate = useNavigate();
  
  const [showPassword, setShowPassword] = useState(false); // State for password visibility
  
  const togglePasswordVisibility = () => setShowPassword((prevShowPassword) => !prevShowPassword);
  const login = (form) => {
    form.preventDefault();
    const data = {
      username: form.target.username.value,
      password: form.target.password.value
    }
    if(data.username === 'youcloud@admin.com' && data.password === 'YouAdmin@674578') {
      toast.success("Welcome " + data.username);
      navigate("/dashboard");
    } else {
      toast.error('Invalid username or password !');
    }
    // api.post('auth/admin/authenticate', data)
    //   .then(response => {
    //     if(response.data.token) {
    //       let newUser = response.data.user;
    //       // console.log(newUser.authStatus);
    //       if (newUser.authStatus === "7") {
    //         // console.log(String(newUser.authStatus));
    //         let passwdExpiry = new Date(newUser.newUsrPasswdExp);
    //         const currentDate = new Date();
    //         // console.log(passwdExpiry, currentDate, passwdExpiry < currentDate);
    //         if (passwdExpiry < currentDate) {
    //           toast.error("Your password has been already expired. Please contact the admin.");
    //         } else {
    //           const timeDifference = passwdExpiry - currentDate;
    //           const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    //           const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    //           const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
    //           // console.log("Welcome "+newUser.firstName+` , Please reset your password, your default password will be expired in ${days} days, ${hours} hours, ${minutes} minutes`)

    //           toast.success(
    //             "Welcome " + newUser.firstName + ` , Please reset your password to Proceed`
    //           );
    //           setLoggedIn(dispatch, true);
    //           setUser(dispatch, response.data.user);
    //           setToken(dispatch, response.data.token);
    //           setLicenseMessage(dispatch, response.data.license);
    //           navigate("/first-password");
    //         }
    //       } else if (String(newUser.authStatus) === "1") {
    //         // console.log("authStatus :", newUser.authStatus);
    //         toast.success("Welcome " + response.data.user.firstName);
    //         setLoggedIn(dispatch, true);
    //         setUser(dispatch, response.data.user);
    //         setToken(dispatch, response.data.token);
    //         setRefreshToken(dispatch, response.data.refreshToken);
    //         setLicenseMessage(dispatch, response.data.license);
    //         // ensure guard sees auth immediately
    //         localStorage.setItem("token", response.data.token);
    //         localStorage.setItem("user", JSON.stringify(response.data.user));
    //         // navigate("/dashboard");
    //         // console.log("[LOGIN] -> /dashboard", response.data);
    //         navigate("/group-config");
    //         // console.log("[LOGIN] -> /group-config", response.data);
    //       } 
    //     }
    //   }) 
    //   .catch(error => {
    //     // console.error("[LOGIN] api error:", error);
    //     const response = error.response;
    //     toast.failure("Connection failure, not able to login");
    //     if(response) toast.error(response.data.message);
    //   });
  }


  return (
    <BasicLayout image={bgImage}>
      {/* The card's header is pulled up 24px (mt={-3}), so this margin is offset by that. */}
      <MDBox display="flex" justifyContent="center" mb={7}>
        <MDBox
          component="img"
          src="/YC_logo.png"
          alt="YouCloud"
          sx={{ height: 96, width: "auto", maxWidth: "100%" }}
        />
      </MDBox>

      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Sign in
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={(values) => login(values)}>
            <MDBox mb={2}>
              <MDInput type="text" label="Username" name="username" fullWidth />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type={showPassword ? "text" : "password"}
                label="Password"
                name="password"
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={togglePasswordVisibility} edge="end">
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton type="submit" variant="gradient" color="info" fullWidth>
                Sign in
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Basic;
